import { FuseAnimate } from "@fuse";
import _ from "@lodash";
import { Fab, withStyles } from "@material-ui/core";
import ImprimirApp from "app/Core/Components/Imprimir/ImprimirApp";
import XAPPComponent from "app/Core/Components/XAPPComponent/XAPPComponent";
import * as AppActions from "app/store/actions";
import classNames from "classnames";
import React from "react";
import { MdAdd } from "react-icons/md";
import { connect } from "react-redux";
import { withRouter } from "react-router-dom";
import ReactTable from "react-table";
import { bindActionCreators } from "redux";
import * as Actions from "./Store/Actions/ChaveActions";

const styles = theme => ({
    root: {
        color: theme.palette.text.primary,
        "& select, input": {
            backgroundColor: theme.palette.background.paper + " !important"
        }
    }
});

class ChaveList extends XAPPComponent {

    state = {
        selected: []
    };

    componentDidMount() {
        const { listFilter, xappRouteParams } = this.props;
        listFilter("SELECIONAR", xappRouteParams);
    }

    componentDidUpdate(prevProps) {
        if (this.props.Chave.error) {
            this.props.showMessage({
                message: this.props.Chave.error,
                variant: "error"
            });
            this.props.Chave.error = null;
        }

        if (this.props.getAcoes() === null || !_.isEqual(this.props.Chave.data, prevProps.Chave.data)) {
            this.props.setAcoes(
                <React.Fragment>
                    {!_.isNull(this.props.Chave.data) &&
                        <ImprimirApp
                            data={this.props.Chave.data}
                            key="btnImprimir"
                            id="EmpresaFinanceiroCaixa"
                            label="Chave"
                            column={this.getColumns()}
                            className="mr-12"
                        />
                    }
                    <Fab
                        id={"fab-add-chave"}
                        color="primary"
                        aria-label="add"
                        onClick={() => { this.props.openDialog({}); }}
                        className="mt-16"
                    >
                        <MdAdd className="text-24 text-white" />
                    </Fab>
                </React.Fragment>
            );
        }
    }

    getColumns = () => {
        return [
            {
                Header: "Código",
                accessor: "codigo",
                width: 300,
            },
            {
                Header: "Descrição",
                accessor: "descricao"
            },
            {
                Header: "Validade",
                accessor: "validadedescricao",
                width: 150,
                className: "justify-center"
            }
        ];
    };

    render() {
        const { Chave, openDialog, classes } = this.props;

        return (
            <FuseAnimate animation="transition.slideUpIn" delay={300}>
                <ReactTable
                    className={classNames(classes.root, "-striped -highlight border-0")}
                    getTrProps={(state, rowInfo) => {
                        return {
                            className: "cursor-pointer",
                            onClick: () => {
                                if (rowInfo) {
                                    openDialog(rowInfo.original);
                                }
                            }
                        };
                    }}
                    data={Chave.data ? Chave.data : []}
                    columns={this.getColumns()}
                    defaultPageSize={10}
                    noDataText="Não existem registros cadastrados!"
                />
            </FuseAnimate>
        );
    }
}


function mapDispatchToProps(dispatch) {
    return bindActionCreators({
        openDialog: Actions.openDialog,
        showMessage: AppActions.showMessage,
    }, dispatch);
}

function mapStateToProps({ Chave }) {
    return {
        Chave: Chave,
    };
}

export default withStyles(styles, { withTheme: true })(withRouter(connect(mapStateToProps, mapDispatchToProps)(ChaveList)));
